<template>
  <div>
    <PageTagline :elements="tagline_elem" />

    <!-- Pagina di login per il servizio -->
    <TsLoginPage :service_title="service_title" :service="service" :cluster="cluster" :comp_credito="comp_credito"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import TsLoginPage from '@/components/tantosvago/TsLoginPage'

export default {
  name: 'TsEdicola',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Portale Edicola", link : 'conv-edicola' } ],

        // variabili che definiscono il servizio experiece con la quale
        // configuriamo la pagina di login.
        service_title: "Portale Edicola",
        service: "zenais",
        cluster: "home",
        comp_credito: "totale"
    }
  },
  components: {
    PageTagline,
    TsLoginPage
  }
}
</script>

<style scoped></style>